var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 24 24",
  width: 32,
  height: 32
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "crown_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#crown_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  className: "crown_svg__leftSegment",
  d: "M0 0v24h12V0L6 14.182 0 0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "crown_svg__rightSegment",
  d: "M12 0v24h12V0l-6 14.182L12 0Z"
}))));
export default SvgCrown;